import { Query } from 'best-modules/utils'
import { sendRequest } from 'best-modules/vue-utils'
import {
  InternalDepartment,
  InternalDepartmentCredentials,
  InternalDepartmentTreeItem,
} from '@/utils/types/internalDepartment'

const internalDepartmentList = (
  query: Query
): Promise<InternalDepartment[]> => {
  return sendRequest({
    name: 'internalDepartmentList',
    method: 'get',
    url: {
      url: '/json/orgStructure/department',
      query,
    },
  })
}

const internalDepartmentTreeList = (
  query: Query
): Promise<Array<Omit<InternalDepartmentTreeItem, 'users'>>> => {
  return sendRequest({
    name: 'internalDepartmentTreeList',
    method: 'get',
    url: {
      url: '/json/orgStructure/department/tree',
      query,
    },
  })
}

const internalDepartmentTreeWithUsersList = (
  query: Query
): Promise<InternalDepartmentTreeItem[]> => {
  return sendRequest({
    name: 'internalDepartmentTreeWithUsersList',
    method: 'get',
    url: {
      url: '/json/orgStructure/department/tree-with-users',
      query,
    },
  })
}

const internalDepartmentCreate = (
  departmentCredentials: InternalDepartmentCredentials
): Promise<InternalDepartment[]> => {
  return sendRequest({
    name: 'internalDepartmentCreate',
    method: 'post',
    url: '/json/orgStructure/department',
    payload: departmentCredentials,
  })
}

const internalDepartmentUpdate = (
  departmentId: number,
  departmentCredentials: InternalDepartmentCredentials
): Promise<InternalDepartment[]> => {
  return sendRequest({
    name: 'internalDepartmentUpdate',
    method: 'put',
    url: `/json/orgStructure/department/${departmentId}`,
    payload: departmentCredentials,
  })
}

const internalDepartmentDelete = (
  departmentId: number
): Promise<InternalDepartment[]> => {
  return sendRequest({
    name: 'internalDepartmentDelete',
    method: 'delete',
    url: `/json/orgStructure/department/${departmentId}`,
  })
}

export {
  internalDepartmentList,
  internalDepartmentTreeList,
  internalDepartmentTreeWithUsersList,
  internalDepartmentDelete,
  internalDepartmentCreate,
  internalDepartmentUpdate,
}
